export default __webpack_public_path__ + "static/media/ellipse_fill.5431a3ee.svg";